<div class="progressbar-box">
    <ul class="progress-bar list-f">
        <li *ngFor="let item of progressBarArray"
            [ngClass]="{'active':item.name === progressBarState, 'color':item.name != progressBarState && item.index != indexItem, 'gray-color': item.index > indexItem}">
            <a>
                    <div class="circle-bg"><img style="margin-top: 7px;" src="{{item.src}}" alt="img"></div>
               
            </a> <p class="text"> {{item.name}}</p></li>
    </ul>
</div>